import React, { useEffect, useState } from "react";

import Icons from "./components/Icons";
import Footer from "./components/footer/Footer";
import AboutUs from "./components/AboutUs";
import GetAllButton from "./components/GetAllButton";
import DepInput from "./components/DepInput";
import ArrInput from "./components/ArrInput";
import DateTimeInput from "./components/DateTimeInput";
import data from "./components/assets/data.json";
import VerticalCarousel from "./components/VerticalCarousel";
import NavBar from "./components/header/navbar/NavBar";
import AuthForm from "./components/auth/AuthForm";
import UserDetails from "./components/UserDetails";

import "./components/header/Header.css";
import "./styles/App.css";
import "react-widgets/styles.css";

function App() {
  const [arrPort, setArrPort] = useState("");
  const [depPort, setDepPort] = useState("");
  const [date, setDate] = useState("");

  const [isSignedIn, setIsSignedIn] = useState(false);

  const [isShowAuthForm, setIsShowAuthForm] = useState(false); // should the panel be displayed or not
  const [isSignInProcess, setIsSignInProcess] = useState(false);
  const [isRegisterProcess, setIsRegisterProcess] = useState(false);
  const [isShowDetails, setIsShowDetails] = useState(false);

  const [userData, setUserData] = useState(null);

  // each time a new page is rendered, check if the user is signed in
  useEffect(() => {
    if (localStorage.getItem("token")) {
      setIsSignedIn(true);
    }
  }, []);

  return (
    <div className="App">
      <div>
        {isShowAuthForm && (
          <AuthForm
            setIsShowAuthForm={setIsShowAuthForm}
            isSignInProcess={isSignInProcess}
            setIsSignInProcess={setIsSignInProcess}
            isRegisterProcess={isRegisterProcess}
            setIsRegisterProcess={setIsRegisterProcess}
            setIsSignedIn={setIsSignedIn}
          />
        )}
      </div>
      <div id="app-root">
        <div className="up-container">
          <div className="row">
            <div className="col-lg-10">
              <h1>
                <img
                  src="FerrywaveLogo.png"
                  alt="logo"
                  width="420"
                  height="110"
                ></img>
              </h1>
            </div>
            <div id="modal-root" className="col-lg-1">
              <br></br> <br></br>
              <br></br>
              <br></br>
              {!isSignedIn && (
                <NavBar
                  isShowAuthForm={isShowAuthForm}
                  setIsShowAuthForm={setIsShowAuthForm}
                  isSignInProcess={isSignInProcess}
                  setIsSignInProcess={setIsSignInProcess}
                  isRegisterProcess={isRegisterProcess}
                  setIsRegisterProcess={setIsRegisterProcess}
                />
              )}
            </div>
          </div>
        </div>
        {isSignedIn && (
          <>
            <UserDetails
              setIsSignedIn={setIsSignedIn}
              isShowDetails={isShowDetails}
              setIsShowDetails={setIsShowDetails}
              userData={userData}
              setUserData={setUserData}
            />
          </>
        )}
        <div id="app-root" className="search">
          <div className="search-form">
            <div className="search-box solid">
              <h1>Journey Planner</h1>
              <br />
              <h3>Departure Port:</h3>
              <DepInput setDepPort={setDepPort} />
              <br />
              <h3>Arrival Port:</h3>
              <ArrInput setArrPort={setArrPort} />
              <br />
              <h3>Date of Departure:</h3>
              <DateTimeInput setDate={setDate} date={date} />
              <br />
              <br />
              <br />
            </div>
          </div>
          <br />
          <br />
          <div id="trip-results">
            <GetAllButton
              arrPort={arrPort}
              depPort={depPort}
              date={date}
              userData={userData}
            />
          </div>
        </div>
        <Icons />
        <div className="search2">
          <VerticalCarousel data={data.slides} leadingText={data.leadingText} />
        </div>
        <AboutUs />
        <Footer />
      </div>
    </div>
  );
}

export default App;
